import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { useGroups } from 'root/src/client/v2/auth/hooks/useGroups';
import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
export function useIsCreator() {
    const { groups } = useGroups();
    return {
        isCreator: groups.includes(AuthGroup.Creator),
    };
}
export function useIsCreatorExclusively() {
    var _a, _b;
    const { authentication } = useAuthentication();
    return {
        isCreator: (_b = (_a = authentication === null || authentication === void 0 ? void 0 : authentication.groups) === null || _a === void 0 ? void 0 : _a.includes(AuthGroup.Creator)) !== null && _b !== void 0 ? _b : false,
    };
}
